import React from 'react';
import { Switch } from 'antd';


const BooleanToggle = ({ onChange, inputProp, toggleLabel }) => {

	return (
		<div className="ts_margin_top">
			<Switch 
				onChange={checked => onChange(checked)} 
				checked={inputProp} 
			/> 
				<strong>{toggleLabel}</strong>
		</div>
	)
};

export default BooleanToggle;
